import React, { ReactNode } from "react";
import { ButtonProps } from "@bookingcom/bui-react";
import useUserAgent from "../../../hooks/useUserAgent";
import { UnifiedPriceTagPriceBreakdownMobile } from "./UnifiedPriceTagPriceBreakdown.mobile";
import { UnifiedPriceTagPriceBreakdownDesktop } from "./UnifiedPriceTagPriceBreakdown.desktop";

export type UnifiedPriceTagPriceBreakdownProps = {
  priceBreakdownTrigger?: ReactNode;
  priceBreakdownTriggerProps?: ButtonProps;
  priceBreakdownContent?: ReactNode;
  priceBreakdownCloseAriaLabel?: string;
  priceBreakdownOnOpen?: () => void;
  priceBreakdownOnClose?: () => void;
};

export const UnifiedPriceTagPriceBreakdown = (props: UnifiedPriceTagPriceBreakdownProps) => {
  const { isMobile } = useUserAgent();

  return isMobile ? (
    <UnifiedPriceTagPriceBreakdownMobile {...props} />
  ) : (
    <UnifiedPriceTagPriceBreakdownDesktop {...props} />
  );
};
